import React, {PureComponent} from 'react';
import ReactQuill from 'react-quill';
import {modules, formats} from 'constants/baseConst';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import _ from 'lodash';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import SelectFieldWrapper from 'modules/blocks/SelectFieldWrapper';
import { inject, observer } from 'mobx-react';
import {REIMBURSEMENT_TYPE, REIMBURSEMENT_TYPES} from 'constants/reimbursementTypes';

@inject('topicsStore')
@observer
class Quiz extends PureComponent {
  changeQuiz = (e, value, index) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    const obj = newQuiz[index];
    obj[e.target.name] = value;
    newQuiz[index] = obj;

    topicsStore.handleChangeQuiz(newQuiz);
  }

  handleHideQuiz = () => {
    const {topicsStore} = this.props;
    const is_visible_quize = !topicsStore.topic.is_visible_quize;
    topicsStore.handleChange({is_visible_quize});
  }

  handleType = (e) => {
    const {topicsStore} = this.props;

    topicsStore.handleChange({ [e.target.name]: e.target.value });
    topicsStore.clearQuizes();
  }

  handleAddOption = key => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    newQuiz[key].options.push({
      body: '',
      correct: '',
    })

    topicsStore.addQuizOption(newQuiz);
  };

  handleRemoveOption = (index, key) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    newQuiz[index].options.splice(key, 1);

    topicsStore.addQuizOption(newQuiz);
  };

  changeQuizOption = (e, value, index, key) => {
    const {topicsStore} = this.props;
    const newQuiz = [...topicsStore.topic.spd_quizzes];
    const obj = newQuiz[index].options[key];
    obj[e.target.name] = value;
    newQuiz[index].options[key] = obj;

    this.props.topicsStore.handleChangeQuiz(newQuiz);
  }

  render() {
    const {topicsStore} = this.props;
    const spd_quizzes = topicsStore.topic.spd_quizzes || [];
    const sortedQuizzes = _.sortBy(spd_quizzes, 'id');
    const errors = topicsStore.errors || {};
    const reimbursementType = REIMBURSEMENT_TYPES[topicsStore.topic.reimbursement_type] || REIMBURSEMENT_TYPES[topicsStore.topic.reimbursement_type] === 0 ?
      REIMBURSEMENT_TYPES[topicsStore.topic.reimbursement_type] : topicsStore.topic.reimbursement_type;

    return (
      <div className="tab-container">
        <div className="row justify-content-center">
          <h3 className='container-header'>Add Quiz</h3>
        </div>
        <div className='row'>
          <div className="col-12 container-body">
            <div className="quiz-conatiner" style={{margin: "25px auto"}}>
              <Checkbox
                label='Show quiz'
                checked={topicsStore.topic.is_visible_quize}
                onCheck={this.handleHideQuiz}
              />
            </div>
          </div>
        </div>
        {topicsStore.topic.is_visible_quize && (
          <div className='row'>
            <div className="col-12 container-body">
              <div className="quiz-conatiner" style={{margin: "25px auto"}}>
                <SelectFieldWrapper
                  elements={REIMBURSEMENT_TYPE}
                  placeholder="Reimbursement type:"
                  name='reimbursement_type'
                  value={reimbursementType}
                  onChange={this.handleType}
                  errorText={errors.reimbursement_type}
                  fullWidth={true}
                />
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-12 container-body">
            <div className="quiz-conatiner">
              { sortedQuizzes.map( (el, idx) =>
                <div className="quiz-wrapper" key={idx}>
                  <TextField
                    hintText={`${idx + 1} Question Title`}
                    fullWidth={true}
                    onChange={(e, newValue) => this.changeQuiz(e, newValue, idx)}
                    name='question'
                    value={el.question}
                    type="text"
                    errorText={topicsStore.getErrorToQuiz(idx).question}
                  />
                  {reimbursementType !== 1 ? (
                    <RadioButtonGroup
                      name="correct"
                      defaultSelected="true"
                      className='quiz-answers'
                      onChange={(e, newValue) => this.changeQuiz(e, newValue, idx)}
                      valueSelected={el.correct.toString()}
                    >
                      <RadioButton
                        value="true"
                        label="TRUE"
                      />
                      <RadioButton
                        value="false"
                        label="FALSE"
                      />
                    </RadioButtonGroup>
                  ) : (
                    <div>
                      {el.options.map((option, key) => (
                        <div key={key} style={{margin: '16px 0'}}>
                          <div>
                            <TextField
                              hintText={`Option body`}
                              onChange={(e, newValue) => this.changeQuizOption(e, newValue, idx, key)}
                              name='body'
                              value={option.body}
                              type="text"
                            />
                            <button className="btn" style={{padding: 0, margin: '8px 0', color: '#28b5f4'}} onClick={() => this.handleRemoveOption(idx, key)}>Remove option</button>
                          </div>
                          <RadioButtonGroup
                            name="correct"
                            defaultSelected="true"
                            className='quiz-answers'
                            onChange={(e, newValue) => this.changeQuizOption(e, newValue, idx, key)}
                            valueSelected={option.correct.toString()}
                          >
                            <RadioButton
                              value="true"
                              label="TRUE"
                            />
                            <RadioButton
                              value="false"
                              label="FALSE"
                            />
                          </RadioButtonGroup>
                        </div>
                      ))}
                      <button className="btn" style={{padding: 0, minWidth: 0, margin: '8px 0', color: '#28b5f4'}} onClick={() => this.handleAddOption(idx)}>+ Add option</button>
                      <ReactQuill
                        name={ 'key_learnings' }
                        placeholder={ 'Key learning points' }
                        value={ el.key_learnings || '' }
                        onChange={ (key_learnings) => this.changeQuiz({target: {name: 'key_learnings'}}, key_learnings, idx) }
                        modules={ modules }
                        formats={ formats }
                        className={ `quill-toolbar-position` }
                      >
                        <div style={{ width: '100%', margin: '16px', border: 0 }}></div>
                      </ReactQuill>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
// const Quiz = ({quiz, changeQuiz}) => (



// <div className="tab-container">
//   <div className="row">
//     <div className="col-12 container-body">
//       <div className="start-quiz">
//         <p>Answer correctly 8 of 10 questions and have the opportunity to obtain a certificate of completion course</p>

//         <button className="btn blue rounded update-btn" type="submit">Take the CPD Quiz</button>
//       </div>
//     </div>
//   </div>
// </div>
// {/* steps */}
// <div className="tab-container">
//   <div className="row">
//     <div className="col-12 container-body">
//       <div className="inprogress-quiz">
        
//         {/* pass number of actual question to class of progress bar */}
//         <div className={`progress-bar n${3}`}>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//           <div className="section"></div>
//         </div>

//         <p className="question">
//           You may need to wear glasses from time to time after surgery, especially at night or in low light levels.
//         </p>
//         <div className="row justify-content-center">
//           <RadioButtonGroup
//             //name="quiz-answer"
//             defaultSelected="true"
//             className='quiz-answers'
//           >
//             <RadioButton
//               value="true"
//               label="TRUE"
//               //style={{display: 'inline-block'}}
//             />
//             <RadioButton
//               value="false"
//               label="FALSE"
//               //style={{display: 'inline-block'}}
//             />
//           </RadioButtonGroup>
//         </div>
//         <div className="row justify-content-center">
//           <button className="btn blue rounded update-btn" type="submit">Next questions</button>
//         </div>
//         <div className="row justify-content-center">
//           <span className='pass-hint'>You need to answer 8 out of 10 questions to pass the test</span>
//         </div>
        
//       </div>

//     </div>
//   </div>
// </div>


// {/* finish */}
//   <div className="tab-container">
//     <div className="row">
//       <div className="col-12 container-body">
//         <div className="finish-quiz">
//           <h2>{true ? "Congratulations!" : "Better luck next time!"}</h2>
//           <h3>{true ? "You have passed the CPD quiz for this module." : "You didn’t passed the CPD quiz for this module."}</h3>
//           <h4>{true ? "You have answered 9 out of 10 questions correctly" : "You need to answer at least 8 questions to pass this CPD quiz"}</h4>

//           <button className="btn blue rounded update-btn" type="submit">{true? "VIEW CPD CERT" : "try one more time"}</button>
//         </div>
//       </div>
//     </div>
//   </div>
// );

export default Quiz;


// WEBPACK FOOTER //
// ./src/modules/topic/components/Quiz.js